import { Actividad } from '@interfaces/interface-bakend/ofertas-laborales/actividad.interface';

interface IconoMapa {
    claves: string[];
    icono: string;
}

// Mapa "nombre del trámite" -> icono Material Icons.
// Se usan iconos clásicos para asegurar el render con la fuente Material+Icons.
const ICONOS: IconoMapa[] = [
    { claves: ['medicament', 'farmac', 'receta'], icono: 'local_pharmacy' },
    {
        claves: ['practica', 'práctica', 'estudio', 'laboratorio', 'analisis', 'análisis'],
        icono: 'science',
    },
    {
        claves: ['internacion', 'internación', 'clinica', 'clínica'],
        icono: 'local_hospital',
    },
    { claves: ['kinesio', 'rehabilit', 'fisioterap'], icono: 'healing' },
    { claves: ['oftalmo', 'vista', 'ocular', 'lente'], icono: 'visibility' },
    { claves: ['cardio', 'corazon', 'corazón'], icono: 'favorite' },
    { claves: ['trauma', 'ortoped', 'protesis', 'prótesis'], icono: 'accessibility' },
    {
        claves: ['empadronamiento', 'inscripcion', 'inscripción', 'alta'],
        icono: 'assignment_ind',
    },
    { claves: ['discapacidad', 'certificado', 'cud'], icono: 'badge' },
    {
        claves: ['traslado', 'ambulancia', 'emergencia', 'movilidad'],
        icono: 'airport_shuttle',
    },
    { claves: ['nutri', 'aliment'], icono: 'restaurant' },
    { claves: ['maternidad', 'embaraz', 'obstetric'], icono: 'pregnant_woman' },
];

const ICONO_FALLBACK = 'medical_services';

/**
 * Devuelve un icono Material Icons para un trámite, en base a su nombre.
 * Fallback genérico: medical_services.
 */
export function iconoTramite(actividad: Actividad | undefined | null): string {
    const nombre = (actividad?.nombre ?? '').toLowerCase();
    const match = ICONOS.find((mapa) =>
        mapa.claves.some((clave) => nombre.includes(clave))
    );
    return match ? match.icono : ICONO_FALLBACK;
}
